import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return 'Trouver des chantiers en électricité : Guide complet'
}